import React from "react";
import { FaWhatsapp, FaEnvelope, FaMapMarkerAlt, FaClock, FaArrowUp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer-section">

      <div className="footer-container">

        {/* Left: Branding & Links */}
        <div className="footer-column">
          <h3 className="footer-brand">Gjirokaster Free Tour</h3>
       <ul className="footer-links">
            <li><a href="/#home">Home</a></li>
            <li><a href="/#about">About</a></li>
            <li><a href="/#tours">Tours</a></li>
            <li><a href="/#contact">Contact</a></li>
          </ul>
        </div>
        {/* Center: Our Tours */}
        <div className="footer-column">
          <h4>Our Tours</h4>
          <ul className="footer-tours">
            <li onClick={() => navigate("/tours/free-walking")} className="clickable">Free Walking Tour</li>
            <li onClick={() => navigate("/tours/berat-castle-private")} className="clickable">Gjirokaster Private Tour</li>
            {/* <li onClick={() => navigate("/paid-tour")} className="clickable">Paid Tour</li> */}
          </ul>
        </div>

        {/* Right: Contact Info */}
        <div className="footer-column">
          <h4>Contact</h4>
          <div className="footer-contact">
            {/* Location → Google Maps */}
            <p className="clickable" onClick={() => window.open(
              "https://maps.app.goo.gl/FsXs9MFn88QTLyQc9"
            )}>
              <FaMapMarkerAlt /> Gjirokaster Free Walking Tour Rruga Zejtareve <span style={{marginLeft: '20px'}}>(To the left of Rrapi Restaurant)</span>
            </p>

            {/* Phone → WhatsApp */}
            <p className="clickable" onClick={() => window.open(
              "https://wa.me/+355686328765",
              "_blank"
            )}>
              <FaWhatsapp /> +355 68 632 8765
            </p>
  
            {/* Email → static */}
          
            <p  onClick={() =>
              window.open("mailto:gjirokastratour@gmail.com")
            }><FaEnvelope /> gjirokastratour@gmail.com</p>
          </div>
        </div>

      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Gjirokaster Free Tour. All rights reserved.</p>

        {/* Back to Top */}
        <div className="back-to-top" onClick={scrollToTop}>
          <FaArrowUp /> <span>Back to Top</span>
        </div>
      </div>
    </footer>
  );
}
